import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/regulatory-affairs-services-para-ivd")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs-services-para-ivd", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/regulatory-affairs", replace: true });
  },
});
